import {Paper, styled} from '@mui/material';

const Sidebar = styled(Paper)({
  width: 300,
  overflow: 'auto',
  position: 'relative',
});

export default Sidebar;
